import Tab from '../tabs/tab.vue';
export default {
  name: 'sizechart',
  components: {
    Tab,
  },
  props: ['productTitle'],
  data() {
    return {
      showSizemodal: false,
      selectedTabIndex: 0,
      tabs: [
        {
          label: 'Sizechart',
          name: 'tab1',
          title: 'Measurements',
          content: `<div class="row g-3">
          <div class="col-lg-6">
            <div class="responsive-table-wrapper">
                  <table class="pop-sizing ext-sizing">
                  <thead>
                  <tr>
                    <th>Women's Sizing-Inches</th>
                        <th>Bust</th>
                        <th>Waist</th>
                    <th>Hips</th>
                    <th>Arm Length</th>
                    <th>Inseam</th>
                  </tr>
                  </thead>
                  <tr>
                    <th>XXS</th>
                    <td>30.5-31.5</td>
                  <td>24-25</td>
                  <td>33.5-34.5</td>
                  <td>29.5</td>
                  <td>30.5</td>
                  </tr>
                  <tr>
                    <th>XS</th>
                  <td>32.5-33.5</td>
                  <td>26-27</td>
                  <td>35.5-36.5</td>
                  <td>30</td>
                  <td>30.5</td>
                  </tr>
                  <tr>
                    <th>S</th>
                    <td>34.5-35.5</td>
                  <td>28-29</td>
                  <td>37.5-38.5</td>
                  <td>30.5</td>
                  <td>30.5</td>
                  </tr>
                   <tr>
                    <th>M</th>
                    <td>36.5-37.5</td>
                  <td>30-31</td>
                  <td>39.5-40.5</td>
                  <td>31</td>
                  <td>30.5</td>
                  </tr>
                     <tr>
                    <th>L</th>
                    <td>38.5-41</td>
                  <td>32-34</td>
                  <td>41.5-43.5</td>
                  <td>31.75</td>
                  <td>30.5</td>
                  </tr>
                     <tr>
                    <th>XL</th>
                        <td>42-44</td>
                  <td>35-37</td>
                  <td>44.5-46.5</td>
                  <td>32.5</td>
                  <td>30.5</td>
                  </tr>
                     <tr>
                    <th>XXL</th>
                    <td>45-47</td>
                  <td>38-41</td>
                  <td>47.5-49.5</td>
                  <td>33.25</td>
                  <td>30.5</td>
                  </tr>
                     <tr>
                    <th>1X</th>
                       <td>41-44</td>
                  <td>36-39</td>
                  <td>45-48</td>
                  <td>31-31.25</td>
                  <td>30.5</td>
                  </tr>
                     <tr>
                    <th>2X</th>
                    <td>45-48</td>
                  <td>40-43</td>
                  <td>49-52</td>
                  <td>31.5-31.75</td>
                  <td>30.5</td>
                  </tr>
                     <tr>
                    <th>3X</th>
                      <td>49-52</td>
                  <td>44-47</td>
                  <td>53-56</td>
                  <td>32-32.25</td>
                  <td>30.5</td>
                  </tr>
                     <tr>
                    <th>4X</th>
                      <td>53-56</td>
                  <td>48-52</td>
                  <td>57-60</td>
                  <td>32.5-33</td>
                  <td>30.5</td>
                  </tr>
                </table></div>
          </div>
          <div class="col-lg-6">
             <div class="responsive-table-wrapper">
                <table class="pop-sizing ext-sizing">
                  <thead>
                  <tr>
                    <th>Women's Sizing-Cm</th>
                        <th>Bust</th>
                        <th>Waist</th>
                    <th>Hips</th>
                    <th>Arm Length</th>
                    <th>Inseam</th>
                  </tr>
                  </thead>
                  <tr>
                    <th>XXS</th>
                    <td>77-80</td>
                  <td>61-64</td>
                  <td>85-88</td>
                  <td>75</td>
                  <td>77.5</td>
                  </tr>
                  <tr>
                    <th>XS</th>
                  <td>82-85</td>
                  <td>66-69</td>
                  <td>90-93</td>
                  <td>76</td>
                  <td>77.5</td>
                  </tr>
                  <tr>
                    <th>S</th>
                    <td>86-90</td>
                  <td>71-74</td>
                  <td>95-98</td>
                  <td>77.5</td>
                  <td>77.5</td>
                  </tr>
                   <tr>
                    <th>M</th>
                    <td>92-96</td>
                  <td>76-79</td>
                  <td>100-103</td>
                  <td>79</td>
                  <td>77.5</td>
                  </tr>
                     <tr>
                    <th>L</th>
                    <td>98-104</td>
                  <td>81-87</td>
                  <td>105-111</td>
                  <td>81</td>
                  <td>77.5</td>
                  </tr>
                     <tr>
                    <th>XL</th>
                        <td>106-112</td>
                  <td>89-94</td>
                  <td>113-118</td>
                  <td>82.5</td>
                  <td>77.5</td>
                  </tr>
                     <tr>
                    <th>XXL</th>
                    <td>114-120</td>
                  <td>96-104</td>
                  <td>120-126</td>
                  <td>84.5</td>
                  <td>77.5</td>
                  </tr>
                     <tr>
                    <th>1X</th>
                       <td>104-112</td>
                  <td>91-99</td>
                  <td>113-122</td>
                  <td>78.5-79.5</td>
                  <td>77.5</td>
                  </tr>
                     <tr>
                    <th>2X</th>
                    <td>113-122</td>
                  <td>100-109</td>
                  <td>123-132</td>
                  <td>80-80.5</td>
                  <td>77.5</td>
                  </tr>
                     <tr>
                    <th>3X</th>
                      <td>123-132</td>
                  <td>110-119</td>
                  <td>133-142</td>
                  <td>81-82</td>
                  <td>77.5</td>
                  </tr>
                     <tr>
                    <th>4X</th>
                      <td>133-142</td>
                  <td>120-132</td>
                  <td>143-152</td>
                  <td>82.5-84</td>
                  <td>77.5</td>
                  </tr>
                </table></div> 
          </div>
        </div>
        
             <div class="responsive-table-wrapper">
                    <table class="pop-sizing ext-sizing">        
                    <thead>
                      <tr>
                        <th>Women's Numeric Bottoms - Inches</th>
                                <th>0</th>
                        <th>2</th>
                        <th>4</th>
                        <th>6</th>
                        <th>8</th>
                        <th>10</th>
                                <th>12</th>
                                <th>14</th>
                                <th>16</th>
                                <th>18</th>
                                <th>20</th>
                      </tr>
                    </thead>
                    <tbody>
                            <tr>
                        <th>Waist</th>
                                <td>26</td>
                        <td>27</td>
                        <td>28</td>
                        <td>29</td>
                        <td>30</td>
                        <td>31</td>
                                <td>32.5</td>
                                <td>34.5</td>
                                <td>36.75</td>
                                <td>39</td>
                                <td>41.25</td>
                      </tr>
                      <tr>
                        <th>Hip</th>
                                <td>35.5</td>
                        <td>36.5</td>
                        <td>37.5</td>
                        <td>38.5</td>
                        <td>39.5</td>
                        <td>40.5</td>
                                <td>42</td>
                                <td>43.75</td>
                                <td>45.5</td>
                                <td>47.5</td>
                                <td>49.5</td>
                      </tr>
                            <tr>
                        <th>Inseam</th>
                                <td>30.5</td>
                        <td>30.5</td>
                        <td>30.5</td>
                        <td>30.5</td>
                        <td>30.5</td>
                        <td>30.5</td>
                                <td>30.5</td>
                                <td>30.5</td>
                                <td>30.5</td>
                                <td>30.5</td>
                                <td>30.5</td>
                      </tr>
                    </tbody>
                  </table></div> 
          
            <div class="responsive-table-wrapper">
                    <table class="pop-sizing ext-sizing">         
                    <thead>
                      <tr>
                        <th>Women's Numeric Bottoms - Cm</th>
                                <th>0</th>
                        <th>2</th>
                        <th>4</th>
                        <th>6</th>
                        <th>8</th>
                        <th>10</th>
                                <th>12</th>
                                <th>14</th>
                                <th>16</th>
                                <th>18</th>
                                <th>20</th>
                      </tr>
                    </thead>
                    <tbody>
                            <tr>
                        <th>Waist</th>
                                <td>66</td>
                        <td>68.5</td>
                        <td>71</td>
                        <td>73.5</td>
                        <td>76</td>
                        <td>78.5</td>
                                <td>82.5</td>
                                <td>87.5</td>
                                <td>93</td>
                                <td>99</td>
                                <td>104.5</td>
                      </tr>
                      <tr>
                        <th>Hip</th>
                                <td>90</td>
                        <td>92.5</td>
                        <td>95</td>
                        <td>97.5</td>
                        <td>100</td>
                        <td>103</td>
                                <td>106.5</td>
                                <td>111</td>
                                <td>115.5</td>
                                <td>120.5</td>
                                <td>125.5</td>
                      </tr>
                            <tr>
                        <th>Inseam</th>
                                <td>77.5</td>
                        <td>77.5</td>
                        <td>77.5</td>
                        <td>77.5</td>
                        <td>77.5</td>
                        <td>77.5</td>
                                <td>77.5</td>
                                <td>77.5</td>
                                <td>77.5</td>
                                <td>77.5</td>
                                <td>77.5</td>
                      </tr>
                    </tbody>
                  </table></div>
        
                  <div class="responsive-table-wrapper"><table class="pop-sizing ext-sizing">
                    <thead>
                      <tr>
                        <th>Cotopaxi Size</th>
                                <th>XXS</th>
                                <th>XS</th>
                        <th>S</th>
                        <th>M</th>
                        <th>L</th>
                        <th>XL</th>
                        <th>XXL</th>
                        <th>1X</th>
                        <th>2X</th>
                        <th>3X</th>
                        <th>4X</th>
                      </tr>
                    </thead>
                    <tbody>
                            <tr>
                        <th>US Numeric Size</th>
                                <td>0</td>
                        <td>0/2</td>
                        <td>4/6</td>
                        <td>8/10</td>
                        <td>12/14</td>
                        <td>16/18</td>
                                <td>20</td>
                        <td>14/16</td>
                        <td>18/20</td>
                        <td>22/24</td>
                        <td>26/28</td>
                      </tr>
                            <tr>
                        <th>UK / AU</th>
                                <td>2</td>
                        <td>4/6</td>
                        <td>8/10</td>
                        <td>12/14</td>
                        <td>16/18</td>
                        <td>20/22</td>
                                <td>24</td>
                        <td>18/20</td>
                        <td>22/24</td>
                        <td>26/28</td>
                        <td>30/32</td>
                      </tr>
                            <tr>
                        <th>DE / NL / DK / SE</th>
                                <td>28</td>
                        <td>30/32</td>
                        <td>34/36</td>
                        <td>38/40</td>
                        <td>42/44</td>
                        <td>46/48</td>
                                <td>50</td>
                        <td>46/48</td>
                        <td>50/52</td>
                        <td>54/56</td>
                        <td>58/60</td>
                      </tr>
                            <tr>
                        <th>FR / ES</th>
                                <td>30</td>
                        <td>32/34</td>
                        <td>36/38</td>
                        <td>40/42</td>
                        <td>44/46</td>
                        <td>48/50</td>
                                <td>52</td>
                        <td>48/50</td>
                        <td>52/54</td>
                        <td>56/58</td>
                        <td>60/62</td>
                      </tr>
                            <tr>
                        <th>Italy</th>
                                <td>34</td>
                        <td>36/38</td>
                        <td>40/42</td>
                        <td>44/46</td>
                        <td>48/50</td>
                        <td>52/54</td>
                                <td>56</td>
                        <td>52/54</td>
                        <td>56/58</td>
                        <td>60/62</td>
                        <td>64/66</td>
                      </tr>
                            <tr>
                        <th>Japan</th>
                                <td>1</td>
                        <td>3/5</td>
                        <td>7/9</td>
                        <td>11/13</td>
                        <td>15/17</td>
                        <td>19/21</td>
                                <td>23</td>
                        <td>N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                    </tbody>
                  </table></div>`,
        },
        {
          label: 'Sizechart',
          name: 'tab2',
          title: 'Measuring Guide',
          content: `
          <div class="row">
          <div class=" col-lg d-flex justify-content-center">
          <img src="//cotopaxi.myshopify.com/cdn/shop/t/136/assets/womens-sizing-extnd_1024x.png" sizes="(max-width: 749px) 75vw,
            (max-width: 989px) 100vw,
            100vw," srcset="//cotopaxi.myshopify.com/cdn/shop/t/136/assets/womens-sizing-extnd_300x.png 320w,
          //cotopaxi.myshopify.com/cdn/shop/t/136/assets/womens-sizing-extnd_600x.png 600w,
          //cotopaxi.myshopify.com/cdn/shop/t/136/assets/womens-sizing-extnd_900x.png 900w,
          //cotopaxi.myshopify.com/cdn/shop/t/136/assets/womens-sizing-extnd_1200x.png 1200w,
          //cotopaxi.myshopify.com/cdn/shop/t/136/assets/womens-sizing-extnd_1500x.png 1500w,
          //cotopaxi.myshopify.com/cdn/shop/t/136/assets/womens-sizing-extnd_1800x.png 1800w,
          //cotopaxi.myshopify.com/cdn/shop/t/136/assets/womens-sizing-extnd_2048x.png 2048w">
          </div>
          <div class="how-to-measure col-lg">
            <h5>Tips for how to measure:</h5>
            <ul>
              <li>Use a flexible tape measure.</li>
              <li>If possible, have someone help you take measurements.</li>		
              <li>Wear something light and close-fitting—like leggings and a t-shirt—so your clothes don’t add to the measurements. Don’t wear anything thick or heavy, like jeans or a jacket.</li>
              <li>Stand up straight with your feet shoulder-width apart.</li>
              <li><b>Chest:</b> With the tape measure parallel to the floor, measure the circumference around the fullest part of your chest.</li>
              <li><b>Waist:</b> With the tape measure parallel to the floor, measure the full circumference of your natural waist (at the crease when you bend to one side).</li>
              <li><b>Hips:</b> With the tape measure parallel to the ground, measure the circumference of the fullest part of your hips (usually around the top of your thighs, where they connect to your torso).</li>
              <li><b>Sleeves:</b> Starting at the base of your neck, measure along your shoulder, then down to the wrist. Your elbow should be slightly bent.</li>
              <li><b>Inseam:</b> Holding the tape measure vertically, measure straight down from your crotch to the floor. Take this measurement without shoes on.</li>
            </ul>
          </div></div>`,
        },
        {
          label: 'Sizechart',
          name: 'tab3',
          title: 'Measurements',
          content: `<div class="row g-3">
          <div class="col-lg-6">
            <div class="responsive-table-wrapper">
                  <table class="pop-sizing ext-sizing">
                    <thead>
                      <tr>
                        <th>Men's Sizing-Inches</th>
                        <th>Chest</th>
                        <th>Waist</th>
                        <th>Hips</th>
                        <th>Arm Length</th>
                        <th>Inseam</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>XS</th>
                          <td>32-34</td>
                          <td>26-28</td>
                          <td>30.5-32.5</td>
                          <td>32</td>
                          <td>32</td>
                      </tr>
                      <tr>
                        <th>S</th>
                          <td>35-37</td>
                          <td>29-31</td>
                          <td>33-36</td>
                          <td>32.5</td>
                          <td>32</td>	
                      </tr>
                      <tr>
                        <th>M</th>
                          <td>38-40</td>
                          <td>32-34</td>
                          <td>37-39</td>
                          <td>33</td>
                          <td>32</td>	
                      </tr>
                      <tr>
                        <th>L</th>
                          <td>41-43</td>
                          <td>35-37</td>
                          <td>40-42</td>
                          <td>33.5</td>
                          <td>32</td>	
                      </tr>
                      <tr>
                        <th>XL</th>
                          <td>44-46.5</td>
                          <td>38-41</td>
                          <td>43-45.5</td>
                          <td>34.25</td>
                          <td>32</td>
                      </tr>
                      <tr>
                      <th>2XL</th>
                        <td>47.5-50</td>
                        <td>42-45</td>
                        <td>46.5-49</td>
                        <td>35</td>
                        <td>32</td>
                      </tr>
                      <tr>
                      <th>3XL</th>
                        <td>51-54</td>
                        <td>46-50</td>
                        <td>50-53</td>
                        <td>36</td>
                        <td>32</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
          </div>
          <div class="col-lg-6">
            <div class="responsive-table-wrapper">
                <table class="pop-sizing ext-sizing">
                    <thead>
                      <tr>
                        <th>Men's Sizing-Cm</th>
                        <th>Chest</th>
                        <th>Waist</th>
                        <th>Hips</th>
                        <th>Arm Length</th>
                        <th>Inseam</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>XS</th>
                          <td>81-86</td>
                          <td>66-71</td>
                          <td>77-82</td>
                          <td>81</td>
                          <td>81</td>
                      </tr>
                      <tr>
                        <th>S</th>
                          <td>88-94</td>
                          <td>73-79</td>
                          <td>84-92</td>
                          <td>82.5</td>
                          <td>81</td>
                      </tr>
                      <tr>
                        <th>M</th>
                          <td>96-102</td>
                          <td>81-87</td>
                          <td>94-99</td>
                          <td>84</td>
                          <td>81</td>
                      </tr>
                      <tr>
                        <th>L</th>
                          <td>104-109</td>
                          <td>89-94</td>
                          <td>101-107</td>
                          <td>85</td>
                          <td>81</td>
                      </tr>
                      <tr>
                        <th>XL</th>
                          <td>111-118</td>
                          <td>96-104</td>
                          <td>109-116</td>
                          <td>87</td>
                          <td>81</td>
                      </tr>
                      <tr>
                        <th>2XL</th>
                          <td>120-127</td>
                          <td>106-115</td>
                          <td>118-125</td>
                          <td>89</td>
                          <td>81</td>
                      </tr>
                      <tr>
                        <th>3XL</th>
                          <td>129-137</td>
                          <td>117-127</td>
                          <td>127-135</td>
                          <td>91.5</td>
                          <td>81</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
          </div>
        </div>
        <div class="responsive-table-wrapper">
          <table class="pop-sizing ext-sizing">
            <thead>
              <tr>
                <th>Men's Numeric Bottoms - Inches</th>
                <th>28</th>
                <th>29</th>
                <th>30</th>
                <th>31</th>
                <th>32</th>
                <th>33</th>
                <th>34</th>
                <th>35</th>
                <th>36</th>
                <th>38</th>
                <th>40</th>
              </tr>
            </thead>
              <tbody>
                <tr>
                  <th>Waist</th>
                    <td>28.5</td>
                    <td>29.5</td>
                    <td>30.5</td>
                    <td>31.5</td>
                    <td>32.5</td>
                    <td>33.5</td>
                    <td>34.5</td>
                    <td>35.5</td>
                    <td>36.75</td>
                    <td>39</td>
                    <td>41.25</td>
                </tr>
                <tr>
                  <th>Hip</th>
                    <td>33.5</td>
                    <td>34.5</td>
                    <td>35.5</td>
                    <td>36.5</td>
                    <td>37.5</td>
                    <td>38.5</td>
                    <td>39.5</td>
                    <td>40.5</td>
                    <td>41.5</td>
                    <td>43.25</td>
                    <td>45</td>
                </tr>
                <tr>
                  <th>Inseam</th>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                    <td>32</td>
                </tr>
              </tbody>
            </table>
          </div>  
          <div class="responsive-table-wrapper">
              <table class="pop-sizing ext-sizing">
                  <thead>
                      <tr>
                        <th>Men's Numeric Bottoms - Cm</th>
                        <th>28</th>
                        <th>29</th>
                        <th>30</th>
                        <th>31</th>
                        <th>32</th>
                        <th>33</th>
                        <th>34</th>
                        <th>35</th>
                        <th>36</th>
                        <th>38</th>
                        <th>40</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>Waist</th>
                        <td>72</td>
                        <td>75</td>
                        <td>77.5</td>
                        <td>80</td>
                        <td>82.5</td>
                        <td>85</td>
                        <td>87.5</td>
                        <td>90</td>
                        <td>93</td>
                        <td>99</td>
                        <td>104.5</td>
                      </tr>
                      <tr>
                        <th>Hip</th>
                          <td>85</td>
                          <td>87.5</td>
                          <td>90</td>
                          <td>92.5</td>
                          <td>95</td>
                          <td>97.5</td>
                          <td>100</td>
                          <td>102.75</td>
                          <td>105.5</td>
                          <td>110</td>
                          <td>114</td>
                      </tr>
                      <tr>
                        <th>Inseam</th>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                          <td>81</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="responsive-table-wrapper">
                  <table class="pop-sizing ext-sizing">
                    <thead>
                      <tr>
                        <th>Cotopaxi Size</th>
                        <th>XS</th>
                        <th>S</th>
                        <th>M</th>
                        <th>L</th>
                        <th>XL</th>
                        <th>2XL</th>
                        <th>3XL</th>
                      </tr>
                    </thead>
                    <tbody>
                        <tr>
                          <th>US Numeric Jacket</th>
                          <td>34/35</td>
                          <td>36/37</td>
                          <td>38/40</td>
                          <td>42/44</td>
                          <td>46/48</td>
                          <td>50/52</td>
                          <td>54</td>
                        </tr>
                      <tr>
                        <th>US Numeric Pant</th>
                        <td>28/29</td>
                        <td>30/31</td>
                        <td>32/34</td>
                        <td>36/38/40</td>
                        <td>42/44</td>
                        <td>46/48</td>
                        <td>50</td>
                      </tr>
                      <tr>
                        <th>UK / AU</th>
                        <td>34</td>
                        <td>36</td>
                        <td>38/40</td>
                        <td>42/44</td>
                        <td>46/48</td>
                        <td>50/52</td>
                        <td>54</td>
                      </tr>
                      <tr>
                        <th>EU</th>
                        <td>44</td>
                        <td>46</td>
                        <td>48/50</td>
                        <td>52/54</td>
                        <td>56/58</td>
                        <td>60/62</td>
                        <td>64</td>
                      </tr>
                      <tr>
                        <th>Japan</th>
                        <td>36</td>
                        <td>38</td>
                        <td>40/42</td>
                        <td>44/46</td>
                        <td>48/50</td>
                        <td>52/54</td>
                        <td>56</td>
                      </tr>
                    </tbody>
                  </table></div>`,
        },
        {
          label: 'Sizechart',
          name: 'tab4',
          title: 'Measuring Guide',
          content: `
        <div class="row">
        <div class=" col-lg d-flex justify-content-center">
        <img src="//www.cotopaxi.com/cdn/shop/t/96/assets/mens-sizing-extnd_1024x.png?" sizes="(max-width: 749px) 75vw,
            (max-width: 989px) 100vw,
            100vw," srcset="//www.cotopaxi.com/cdn/shop/t/96/assets/mens-sizing-extnd_300x.png 320w,
          //www.cotopaxi.com/cdn/shop/t/96/assets/mens-sizing-extnd_600x.png 600w,
          //www.cotopaxi.com/cdn/shop/t/96/assets/mens-sizing-extnd_900x.png 900w,
          //www.cotopaxi.com/cdn/shop/t/96/assets/mens-sizing-extnd_1200x.png 1200w,
          //www.cotopaxi.com/cdn/shop/t/96/assets/mens-sizing-extnd_1500x.png 1500w,
          //www.cotopaxi.com/cdn/shop/t/96/assets/mens-sizing-extnd_1800x.png 1800w,
          //www.cotopaxi.com/cdn/shop/t/96/assets/mens-sizing-extnd_2048x.png 2048w">
        </div>
        <div class="how-to-measure col-lg">
          <h5>Tips for how to measure:</h5>
          <ul>
            <li>Use a flexible tape measure.</li>
            <li>If possible, have someone help you take measurements.</li>		
            <li>Wear something light and close-fitting—like leggings and a t-shirt—so your clothes don't add to the measurements. Don't wear anything thick or heavy, like jeans or a jacket.</li>
            <li>Stand up straight with your feet shoulder-width apart.</li>
            <li><b>Chest:</b> With the tape measure parallel to the floor, measure the circumference around the fullest part of your chest.</li>
            <li><b>Waist:</b> With the tape measure parallel to the floor, measure the full circumference of your natural waist (at the crease when you bend to one side).</li>
            <li><b>Hips:</b> With the tape measure parallel to the ground, measure the circumference of the fullest part of your hips (usually around the top of your thighs, where they connect to your torso).</li>
            <li><b>Sleeves:</b> Starting at the base of your neck, measure along your shoulder, then down to the wrist. Your elbow should be slightly bent.</li>
            <li><b>Inseam:</b> Holding the tape measure vertically, measure straight down from your crotch to the floor. Take this measurement without shoes on.</li>
          </ul>
        </div></div>`,
        },
        {
          label: 'Sizechart',
          name: 'tab5',
          title: 'Measurements',
          content: `
          <p class="col-lg-8 offset-lg-2 text-center">The unisex Libre Socks feature a classic-crew, below-the-calf fit. The versatile medium-weight construction strikes a nice balance between light mapping over the top of the foot and cuff, with slightly thicker cushioned heels and toes.</p>
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
            <div class="responsive-table-wrapper">
            <table class="pop-sizing">
              <thead>
                <tr>
                  <th>Size</th>
                  <th>Women</th>
                  <th>Men</th>
                </tr>
              </thead>
            <tbody>
            <tr>
              <th>Small</th>
              <td>5-7 (EU: 35.5-37.5)</td>
              <td></td>
            </tr>
            <tr>
              <th>Medium</th>
              <td>7.5-11 (EU: 38-42)</td>
              <td>5-9 (EU: 38-42)</td>
            </tr>
            <tr>
              <th>Large</th>
              <td></td>
              <td>9.5-12 (EU: 42.5-45)</td>
            </tr>
          </tbody>
          </table>
           </div>
            </div>
          </div>`,
        },
        {
          label: 'Sizechart',
          name: 'tab6',
          title: 'Measurements',
          content: `<div class="responsive-table-wrapper">
          <table class="pop-sizing ext-sizing mb-2">
            <thead>
              <tr>
                <th>Kids' Measurements - Inches</th>
                <th>XS</th>
                <th>S</th>
                <th>M</th>
                <th>L</th>
                <th>XL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Chest</th>
                <td>23-24</td>
                <td>25-26.5</td>
                <td>27-28.5</td>
                <td>29-32</td>
                <td>32-33.5</td>
              </tr>
              <tr>
                <th>Waist</th>
                  <td>22-23</td>
                  <td>24-25</td>
                  <td>25-26.5</td>
                  <td>27-29.5</td>
                  <td>30-31</td>
              </tr>
              <tr>
                <th>Hips</th>
                <td>24-25</td>
                <td>26-28</td>
                <td>28-30.5</td>
                <td>31-33.5</td>
                <td>34-35</td>
              </tr>
              <tr>
                <th>Arm Length</th>
                <td>21-22</td>
                <td>23-24</td>
                <td>25-26.5</td>
                <td>27-29</td>
                <td>29.5-30.5</td>
              </tr>
              <tr>
                <th>Inseam</th>
                <td>18.5-20.5</td>
                <td>21-24.5</td>
                <td>25-27.5</td>
                <td>28-31</td>
                <td>31.5</td>
              </tr>
              <tr>
                <th>Height</th>
                <td>44-47</td>
                <td>48-52</td>
                <td>53-59</td>
                <td>60-64</td>
                <td>65-67</td>
              </tr>
              <tr>
                <th>Weight (lbs)</th>
                  <td>39-48</td>
                  <td>52-68</td>
                  <td>71-100</td>
                  <td>99-125</td>
                  <td>118-135</td>
              </tr>
            </tbody>
          </table>
        </div>	
        <div class="responsive-table-wrapper">
            <table class="pop-sizing ext-sizing mb-2">
            <thead>
              <tr>
                <th>Kids' Measurements - Cm</th>
                  <th>XS</th>
                  <th>S</th>
                  <th>M</th>
                  <th>L</th>
                  <th>XL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th>Chest</th>
                <td>58.5-62</td>
                <td>63-67</td>
                <td>68-72.5</td>
                <td>73-80</td>
                <td>81-85</td>
              </tr>
              <tr>
                <th>Waist</th>
                  <td>56-58.5</td>
                  <td>59-62.5</td>
                  <td>63-67.5</td>
                  <td>69-75</td>
                  <td>76-79</td>
              </tr>
              <tr>
                <th>Hips</th>
                  <td>61-63.5</td>
                  <td>64-71</td>
                  <td>72-77.5</td>
                  <td>78-85</td>
                  <td>86-89</td>
              </tr>
              <tr>
                <th>Arm Length</th>
                  <td>53-56</td>
                  <td>57-61</td>
                  <td>62-67</td>
                  <td>68-74</td>
                  <td>75-77.5</td>
              </tr>
              <tr>
                <th>Inseam</th>
                  <td>77.5</td>
                  <td>77.5</td>
                  <td>77.5</td>
                  <td>77.5</td>
                  <td>77.5</td>
              </tr>
              <tr>
                <th>Height</th>
                  <td>111-118</td>
                  <td>119-132</td>
                  <td>133-149</td>
                  <td>150-162.5</td>
                  <td>163-170</td>
              </tr>
              <tr>
                <th>Weight (kg)</th>
                  <td>17.5-21.75</td>
                  <td>23.5-31</td>
                  <td>32-43</td>
                  <td>44.5-54.5</td>
                  <td>53.5-60</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="responsive-table-wrapper">	
            <table class="pop-sizing ext-sizing mb-2">
            <thead>
              <tr>
                <th>Cotopaxi Size</th>
                   <th>XS</th>
                  <th>S</th>
                  <th>M</th>
                  <th>L</th>
                  <th>XL</th>
              </tr>
            </thead>
            <tbody>
                <tr>
                <th>US Numeric Size</th>
                  <td>5/6</td>
                  <td>7/8</td>
                  <td>10/12</td>
                  <td>14/16</td>
                  <td>18</td>
              </tr>
              <tr>
                <th>UK / AU</th>
                  <td>5-6</td>
                  <td>7-8</td>
                  <td>9-12</td>
                  <td>13-16</td>
                  <td>17-18</td>
              </tr>
              <tr>
                <th>EU</th>
                  <td>110-116</td>
                  <td>122-128</td>
                  <td>134-152</td>
                  <td>158-170</td>
                  <td>176</td>
              </tr>
            </tbody>
          </table> 
        </div>`,
        },
        {
          label: 'Sizechart',
          name: 'tab7',
          title: 'Measuring Guide',
          content: `<div class="row">
          <div class="col-md-6">
                  <img src="//cotopaxi.myshopify.com/cdn/shop/t/136/assets/girls-size-chart_1024x.png" sizes="(max-width: 749px) 50vw,
                    (max-width: 989px) 100vw,
                    100vw," srcset="//cotopaxi.myshopify.com/cdn/shop/t/136/assets/girls-size-chart_300x.png 320w,
                  //cotopaxi.myshopify.com/cdn/shop/t/136/assets/girls-size-chart_600x.png 600w,
                  //cotopaxi.myshopify.com/cdn/shop/t/136/assets/girls-size-chart_900x.png 900w,
                  //cotopaxi.myshopify.com/cdn/shop/t/136/assets/girls-size-chart_1200x.png 1200w" class="kids" />
              </div>
              <div class="col-md-6">
        <img src="//cotopaxi.myshopify.com/cdn/shop/t/136/assets/boys-size-chart_1024x.png" sizes="(max-width: 749px) 50vw,
                    (max-width: 989px) 100vw,
                    100vw," srcset="//cotopaxi.myshopify.com/cdn/shop/t/136/assets/boys-size-chart_300x.png 320w,
                  //cotopaxi.myshopify.com/cdn/shop/t/136/assets/boys-size-chart_600x.png 600w,
                  //cotopaxi.myshopify.com/cdn/shop/t/136/assets/boys-size-chart_900x.png 900w,
                  //cotopaxi.myshopify.com/cdn/shop/t/136/assets/boys-size-chart_1200x.png 1200w" class="kids" /> 
              </div>
          </div>	  
         <div class="row">
          <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2 mt-5 how-to-measure">
            <h5>Tips for how to measure:</h5>
                <ul>
                      <li>Use a flexible tape measure.</li>
                      <li>If possible, have someone help you take measurements.</li>		
                      <li>Wear something light and close-fitting—like leggings and a t-shirt—so your clothes don't add to the measurements. Don't wear anything thick or heavy, like jeans or a jacket.</li>
                      <li>Stand up straight with your feet shoulder-width apart.</li>
                      <li><b>Chest:</b> With the tape measure parallel to the floor, measure the circumference around the fullest part of your chest.</li>
                      <li><b>Waist:</b> With the tape measure parallel to the floor, measure the full circumference of your natural waist (at the crease when you bend to one side).</li>
                      <li><b>Hips:</b> With the tape measure parallel to the ground, measure the circumference of the fullest part of your hips (usually around the top of your thighs, where they connect to your torso).</li>
                      <li><b>Sleeves:</b> Starting at the base of your neck, measure along your shoulder, then down to the wrist. Your elbow should be slightly bent.</li>
                      <li><b>Inseam:</b> Holding the tape measure vertically, measure straight down from your crotch to the floor. Take this measurement without shoes on.</li>
                </ul>
          </div>     
        </div>
      </div>`,
        },
        {
          label: 'Sizechart',
          name: 'tab8',
          title: 'Measurements',
          content: `<h5>Renovo Apparel Sizing</h5>
          <p><small><em>All measurements refer to body measurements</em></small></p>
          <div class="row g-3">
             <div class="col col-lg-6">
                <div class="responsive-table-wrapper">
                   <table class="pop-sizing ext-sizing">
                      <thead>
                         <tr>
                            <th>Sizing-Inches</th>
                            <th>S/M</th>
                            <th>L/XL</th>
                         </tr>
                      </thead>
                      <tbody>
                         <tr>
                            <th>Chest</th>
                            <td>35-39</td>
                            <td>40-44</td>
                         </tr>
                         <tr>
                            <th>Waist</th>
                            <td>30-34</td>
                            <td>35-39</td>
                         </tr>
                         <tr>
                            <th>Hip</th>
                            <td>34-38</td>
                            <td>39-43</td>
                         </tr>
                         <tr>
                            <th>Arm Length</th>
                            <td>33-33.5</td>
                            <td>34.5-35</td>
                         </tr>
                      </tbody>
                   </table>
                </div>
             </div>
             <div class="col col-lg-6">
                <div class="responsive-table-wrapper">
                   <table class="pop-sizing ext-sizing">
                      <thead>
                         <tr>
                            <th>Sizing-Cm</th>
                            <th>S/M</th>
                            <th>L/XL</th>
                         </tr>
                      </thead>
                      <tbody>
                         <tr>
                            <th>Chest</th>
                            <td>89-99</td>
                            <td>101.5-111.5</td>
                         </tr>
                         <tr>
                            <th>Waist</th>
                            <td>76.5-86.5</td>
                            <td>89-99</td>
                         </tr>
                         <tr>
                            <th>Hip</th>
                            <td>86.5-96.5</td>
                            <td>99-109</td>
                         </tr>
                         <tr>
                            <th>Arm Length</th>
                            <td>83-85</td>
                            <td>87-89</td>
                         </tr>
                      </tbody>
                   </table>
                </div>
             </div>
          </div>
          <div class="row">
          <div class="responsive-table-wrapper">
          <h5 class="mt-5">International Size Conversion - Men's</h5>
          <table class="pop-sizing ext-sizing">
             <thead>
                <tr>
                   <th>Cotopaxi Size</th>
                   <th>XS</th>
                   <th>S</th>
                   <th>M</th>
                   <th>L</th>
                   <th>XL</th>
                   <th>2XL</th>
                   <th>3XL</th>
                </tr>
             </thead>
             <tbody>
                <tr>
                   <th>Cotopaxi Size - Renovo</th>
                   <td>&nbsp;</td>
                   <td>S/M</td>
                   <td>S/M</td>
                   <td>L/XL</td>
                   <td>L/XL</td>
                   <td>&nbsp;</td>
                   <td>&nbsp;</td>
                </tr>
                <tr>
                   <th>US Numeric Size</th>
                   <td>32</td>
                   <td>34/36</td>
                   <td>38/40</td>
                   <td>42/44</td>
                   <td>46/48</td>
                   <td>50/52</td>
                   <td>54</td>
                </tr>
                <tr>
                   <th>UK / AU</th>
                   <td>32</td>
                   <td>34/36</td>
                   <td>38/40</td>
                   <td>42/44</td>
                   <td>46/48</td>
                   <td>50/52</td>
                   <td>54</td>
                </tr>
                <tr>
                   <th>EU</th>
                   <td>42</td>
                   <td>44/46</td>
                   <td>48/50</td>
                   <td>52/54</td>
                   <td>56/58</td>
                   <td>60/62</td>
                   <td>64</td>
                </tr>
                <tr>
                   <th>Japan</th>
                   <td>34</td>
                   <td>36/38</td>
                   <td>40/42</td>
                   <td>44/46</td>
                   <td>48/50</td>
                   <td>52/54</td>
                   <td>56</td>
                </tr>
             </tbody>
          </table>
         </div>
        </div>
        <div class="row">
        <div class="responsive-table-wrapper">
             <h5 class="mt-5">International Size Conversion - Women's</h5>
             <table class="pop-sizing ext-sizing">
                <thead>
                   <tr>
                      <th>Cotopaxi Size</th>
                      <th>XXS</th>
                      <th>XS</th>
                      <th>S</th>
                      <th>M</th>
                      <th>L</th>
                      <th>XL</th>
                      <th>2XL</th>
                   </tr>
                </thead>
                <tbody>
                   <tr>
                      <th>Cotopaxi Size - Renovo</th>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>S/M</td>
                      <td>S/M</td>
                      <td>S/M</td>
                      <td>L/XL</td>
                      <td>L/XL</td>
                   </tr>
                   <tr>
                      <th>US Numeric Size</th>
                      <td>00</td>
                      <td>0/2</td>
                      <td>4/6</td>
                      <td>8/10</td>
                      <td>12/14</td>
                      <td>16/18</td>
                      <td>20</td>
                   </tr>
                   <tr>
                      <th>UK / AU</th>
                      <td>2</td>
                      <td>4/6</td>
                      <td>8/10</td>
                      <td>12/14</td>
                      <td>16/18</td>
                      <td>20/22</td>
                      <td>24</td>
                   </tr>
                   <tr>
                      <th>DE / NL / DK / SE</th>
                      <td>28</td>
                      <td>30/32</td>
                      <td>34/36</td>
                      <td>38/40</td>
                      <td>42/44</td>
                      <td>46/48</td>
                      <td>50</td>
                   </tr>
                   <tr>
                      <th>FR / ES</th>
                      <td>30</td>
                      <td>32/34</td>
                      <td>36/38</td>
                      <td>40/42</td>
                      <td>44/46</td>
                      <td>48/50</td>
                      <td>52</td>
                   </tr>
                   <tr>
                      <th>Italy</th>
                      <td>34</td>
                      <td>36/38</td>
                      <td>40/42</td>
                      <td>44/46</td>
                      <td>48/50</td>
                      <td>52/54</td>
                      <td>56</td>
                   </tr>
                   <tr>
                      <th>Japan</th>
                      <td>1</td>
                      <td>3/5</td>
                      <td>7/9</td>
                      <td>11/13</td>
                      <td>15/17</td>
                      <td>19/21</td>
                      <td>23</td>
                   </tr>
                </tbody>
             </table>
          </div>
        </div>
          <div class="row">
             <div class="col-md-10 offset-md-1 col-lg-8 offset-lg-2 mt-5 how-to-measure">
                <h5>Tips for how to measure:</h5>
                <ul>
                   <li>Use a flexible tape measure.</li>
                   <li>If possible, have someone help you take measurements.</li>
                   <li>Wear something light and close-fitting—like leggings and a t-shirt—so your clothes don't add to the measurements. Don't wear anything thick or heavy, like jeans or a jacket.</li>
                   <li>Stand up straight with your feet shoulder-width apart.</li>
                   <li><b>Chest:</b> With the tape measure parallel to the floor, measure the circumference around the fullest part of your chest.</li>
                   <li><b>Waist:</b> With the tape measure parallel to the floor, measure the full circumference of your natural waist (at the crease when you bend to one side).</li>
                   <li><b>Hips:</b> With the tape measure parallel to the ground, measure the circumference of the fullest part of your hips (usually around the top of your thighs, where they connect to your torso).</li>
                   <li><b>Sleeves:</b> Starting at the base of your neck, measure along your shoulder, then down to the wrist. Your elbow should be slightly bent.</li>
                   <li><b>Inseam:</b> Holding the tape measure vertically, measure straight down from your crotch to the floor. Take this measurement without shoes on.</li>
                </ul>
             </div>
          </div>`,
        },
      ],
      womensTabs: [0, 1],
      mensTabs: [2, 3],
      sockTabs: [4],
      kidsTabs: [5, 6],
      renovoTabs: [7],
      activeTab: 'tab1',
    };
  },
  methods: {
    filteredTabs(tabsToUse) {
      if (!Array.isArray(tabsToUse)) return [];
      return this.tabs.filter((_, index) => tabsToUse.includes(index));
    },
    selectTab(i) {
      this.selectedTabIndex = i;
    },
  },
  mounted() {
    this.selectTab(0);
  },
};
